import React from 'react';

import { Box, BoxProps } from '@tanium/react-box';

import { ExtendAndOverride } from '../../utils/ExtendAndOverride';

interface LegendCircleIconOwnProps {
  /**
   * The color of the icon.
   */
  color: BoxProps['bg'];
}

export type LegendCircleIconProps = ExtendAndOverride<LegendCircleIconOwnProps, Omit<BoxProps, 'css'>>;

export const LegendCircleIcon = ({ color, ...boxProps }: LegendCircleIconProps): JSX.Element => {
  return <Box size="12px" borderRadius="50%" {...boxProps} bg={color} />;
};
